var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnnoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 190.745,
    height: 197.48,
    viewBox: "0 0 190.745 197.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.159,
    y1: 0.751,
    x2: 0.968,
    y2: 0.156,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#782767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#a01a4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#d10a33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e40428"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6106",
    "data-name": "Group 6106",
    transform: "translate(14817.945 20299.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6104",
    "data-name": "Group 6104",
    transform: "translate(-14817.945 -20299.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6632",
    "data-name": "Path 6632",
    d: "M408.47,408.676a44.41,44.41,0,0,0,.6-7.153V299.337a44.369,44.369,0,0,0-44.369-44.369H262.724a44.367,44.367,0,0,0-44.367,44.369V401.523c0,.187.026.367.028.554v6a44.368,44.368,0,0,0,44.368,44.369H364.735A44.368,44.368,0,0,0,409.1,408.08V401.5A44.426,44.426,0,0,1,408.47,408.676Zm-40.634,37.039c.5-.035,1.02-.033,1.52-.085C368.856,445.682,368.341,445.681,367.837,445.715Zm4.06-.472c.717-.118,1.441-.215,2.146-.367C373.337,445.027,372.614,445.126,371.9,445.243Zm4.407-.948c.761-.207,1.523-.407,2.267-.652C377.826,443.887,377.066,444.09,376.3,444.295Zm4.3-1.4c.78-.3,1.555-.61,2.313-.952C382.158,442.288,381.385,442.6,380.6,442.9Zm4.122-1.823q1.192-.606,2.346-1.28Q385.919,440.469,384.726,441.075Zm3.9-2.223c.82-.528,1.618-1.088,2.4-1.667C390.241,437.763,389.446,438.324,388.625,438.852Zm3.651-2.6c.877-.7,1.717-1.437,2.539-2.2C393.992,434.812,393.154,435.552,392.276,436.249Zm3.374-2.956c1.059-1.032,2.073-2.108,3.025-3.241C397.722,431.183,396.71,432.261,395.65,433.293Zm12.672-23.64c-.174.935-.4,1.851-.628,2.765C407.926,411.5,408.149,410.588,408.322,409.653Zm-.949,4.014c-.246.864-.526,1.709-.822,2.55C406.847,415.377,407.127,414.529,407.373,413.667Zm-1.3,3.857q-.473,1.218-1.011,2.4Q405.6,418.741,406.074,417.524Zm-1.625,3.674c-.383.771-.775,1.533-1.2,2.279C403.672,422.731,404.065,421.968,404.448,421.2Zm-1.927,3.472c-.451.736-.9,1.469-1.4,2.175C401.617,426.139,402.07,425.405,402.521,424.669Zm-2.18,3.223c-.53.714-1.053,1.432-1.623,2.112C399.287,429.325,399.812,428.607,400.341,427.893Z",
    transform: "translate(-218.357 -254.968)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6105",
    "data-name": "Group 6105",
    transform: "translate(-14792.291 -20260.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6097",
    "data-name": "Group 6097",
    transform: "translate(2.381 3.342)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6634",
    "data-name": "Path 6634",
    d: "M273.9,314.853a57.2,57.2,0,0,1,20.872-5.008l.961-.047h60.584a41.148,41.148,0,0,0,27.709-15.764h-99.7l-.574.028a41.117,41.117,0,0,0-38.38,49.048A57.492,57.492,0,0,1,273.9,314.853Z",
    transform: "translate(-244.593 -294.034)",
    fill: "#0e1113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6635",
    "data-name": "Path 6635",
    d: "M343.431,406.247h17.718v-5.861h0V390.22h-64.4a25.04,25.04,0,0,1-25.022-23.555c-.03-.507-.051-1.013-.051-1.521h0c0-.5.02-1.01.05-1.514a25.058,25.058,0,0,1,23.84-23.529l.208-.011,56.852-.028a41.136,41.136,0,0,0,30.645-16.007h-87.9l-.573.029c-1.289.06-2.574.18-3.849.361s-2.54.422-3.792.722-2.489.658-3.708,1.075-2.418.891-3.594,1.422a41.241,41.241,0,0,0-10.842,7.137q-.688.628-1.348,1.289a41.033,41.033,0,0,0-11.825,24.956c-.135,1.361-.2,2.729-.2,4.1a41.2,41.2,0,0,0,1.832,12.149,40.712,40.712,0,0,0,1.412,3.864q.773,1.827,1.719,3.57a41.187,41.187,0,0,0,16.564,16.566q1.739.943,3.568,1.717a41.092,41.092,0,0,0,16.017,3.242h46.68Z",
    transform: "translate(-243.835 -291.972)",
    fill: "#0e1113"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6099",
    "data-name": "Group 6099",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6098",
    "data-name": "Group 6098"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6636",
    "data-name": "Path 6636",
    d: "M271.671,311.726a57.185,57.185,0,0,1,20.872-5.008l.962-.048h60.584A41.149,41.149,0,0,0,381.8,290.907H282.1l-.573.028a41.117,41.117,0,0,0-38.38,49.048,57.489,57.489,0,0,1,28.525-28.257Z",
    transform: "translate(-242.365 -290.907)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6637",
    "data-name": "Path 6637",
    d: "M341.2,403.12h17.719v-5.862h0V387.094h-64.4A25.044,25.044,0,0,1,269.5,363.536c-.03-.506-.05-1.012-.05-1.52h0c0-.506.019-1.011.05-1.515a25.06,25.06,0,0,1,23.84-23.529l.207-.01,56.852-.027a41.13,41.13,0,0,0,30.644-16.007H293.145l-.573.028q-1.934.09-3.849.362t-3.793.721q-1.877.451-3.707,1.076t-3.595,1.423a41.218,41.218,0,0,0-10.841,7.136q-.688.628-1.347,1.288a41.041,41.041,0,0,0-11.826,24.956c-.136,1.36-.2,2.729-.2,4.1a41.148,41.148,0,0,0,1.832,12.15,40.653,40.653,0,0,0,1.411,3.862q.774,1.828,1.719,3.571a41.21,41.21,0,0,0,16.563,16.564q1.741.944,3.57,1.718a40.862,40.862,0,0,0,5.842,1.969q1.991.506,4.027.814a41.174,41.174,0,0,0,6.148.46H341.2Z",
    transform: "translate(-241.606 -288.845)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnnoLogo);
export default __webpack_public_path__ + "static/media/enno-logo.d923165cb3873ae1b96e78b67c1a43f0.svg";
export { ForwardRef as ReactComponent };